/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

/**
 * @nullable
 */
export type ListingDetailResponseDtoApartmentSubtype = typeof ListingDetailResponseDtoApartmentSubtype[keyof typeof ListingDetailResponseDtoApartmentSubtype] | null;


export const ListingDetailResponseDtoApartmentSubtype = {
  STANDARD: 'STANDARD',
  LOFT: 'LOFT',
  MAISONETTE: 'MAISONETTE',
  PENTHOUSE: 'PENTHOUSE',
} as const;
